



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import Swal from 'sweetalert2';

@Component({
  components: {}
})
export default class NumberedLine extends Vue {
  $refs!: { root: HTMLElement; line: HTMLElement; }

  @Prop()
  labels!: string[];

  @Prop({ default: 1 })
  currentNumber!: number;

  @Prop({ default: false })
  active!: boolean;

  @Prop({default: ()=>{return new Array<{ number: number, title: string, text: string }>();}})
  messages!: { number: number, title: string, text: string }[];

  click(number: number) {
    let message = this.messages.filter((item) => { return item.number == number })[0];
    if (message) {
      Swal.fire({
        type: 'info',
        title: message.title,
        text: message.text,
      });
    } else {
      this.$emit("selectElement", number);
    }
  }

  @Watch("currentNumber")
  changeCurrentNumber() {
    this.animateLineToCurrentNumber();
  }

  @Watch("active")
  changeActivity(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.show();
    } else {
      this.hide();
    }
  }

  animateLineToCurrentNumber() {
    if (this.currentNumber == 0) return;
    let line = this.$refs.root.querySelector<HTMLElement>(".numbered-line__line");
    let elements = this.$refs.root.querySelectorAll<HTMLElement>(".numbered-line__section");
    let currentElement = elements[this.currentNumber - 1];
    let number = currentElement.querySelector<HTMLElement>(".numbered-line__number");
    this.$refs.line.style.width = `${(currentElement.offsetLeft - line!.offsetLeft) + (number!.offsetLeft + (number!.offsetWidth / 2))}px`;
  }

  hide(withAnimation: boolean = true) {
    let line = this.$refs.root.querySelector<HTMLElement>(".numbered-line__line");
    let elements = this.$refs.root.querySelectorAll<HTMLElement>(".numbered-line__section");
    if (!withAnimation) {
      elements.forEach(element => {
        let number = element.querySelector<HTMLElement>(".numbered-line__number");
        let text = element.querySelector<HTMLElement>(".numbered-line__text");

        line!.style.opacity = "0";
        (anime as any).set(number, { translateY: -number!.offsetHeight + "px" });
        (anime as any).set(text, { translateY: (element.offsetHeight - text!.offsetTop) + "px" });
      });
    } else {
      for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        let number = element.querySelector<HTMLElement>(".numbered-line__number");
        let text = element.querySelector<HTMLElement>(".numbered-line__text");

        anime({
          targets: line,
          duration: 300,
          easing: "easeOutQuad",
          opacity: 0
        });

        anime({
          targets: number,
          duration: 600,
          easing: "easeOutQuad",
          translateY: -number!.offsetHeight,
          delay: () => {
            return 70 * index
          }
        });

        anime({
          targets: text,
          duration: 600,
          easing: "easeOutQuad",
          translateY: (element.offsetHeight - text!.offsetTop),
          delay: () => {
            return 70 * index
          }
        });
      }
    }
  }

  show() {
    let line = this.$refs.root.querySelector<HTMLElement>(".numbered-line__line");
    let innerLine = this.$refs.root.querySelector<HTMLElement>(".numbered-line__line > div");
    let elements = this.$refs.root.querySelectorAll<HTMLElement>(".numbered-line__section");

    line!.style.opacity = "0";
    innerLine!.style.opacity = "0";
    innerLine!.style.width = "0";

    anime({
      targets: line,
      duration: 300,
      easing: "easeOutQuad",
      opacity: 1,
      complete: () => {
        this.animateLineToCurrentNumber();
        innerLine!.style.opacity = "1";
      }
    });

    for (let index = 0; index < elements.length; index++) {
      const element = elements[index];
      let number = element.querySelector<HTMLElement>(".numbered-line__number");
      let text = element.querySelector<HTMLElement>(".numbered-line__text");

      anime({
        targets: number,
        duration: 600,
        easing: "easeOutQuad",
        translateY: 0,
        delay: () => {
          return 70 * index
        }
      });

      anime({
        targets: text,
        duration: 600,
        easing: "easeOutQuad",
        translateY: 0,
        delay: () => {
          return 70 * index
        }
      });
    }
  }

  mounted() {
    window.addEventListener("resize", () => {
      if (this.active) this.animateLineToCurrentNumber();
    });

    this.hide(false);
  }
}
